package org.catharsis.spendtel

import org.catharsis.spendtel.core.firebase.initializeWebFirebase

object AppInitializer {
    fun onApplicationStart() {
        initializeWebFirebase()
        onApplicationStartPlatformSpecific()
    }
}
